import SearchFilter from 'records/SearchFilter'

export const SEARCH_BACKGROUND_FILTER_MAINTAIN = 'SEARCH_BACKGROUND_FILTER_MAINTAIN';
export const SEARCH_BACKGROUND_FILTER_RESET_STATE = 'SEARCH_BACKGROUND_FILTER_RESET_STATE';
export const SEARCH_BACKGROUND_FILTER_PAGE_SIZE = 'SEARCH_BACKGROUND_FILTER_PAGE_SIZE';

export function searchBackgroundFilterMaintain_succ(data) {
  return {
    type: SEARCH_BACKGROUND_FILTER_MAINTAIN,
    data,
  };
}

export function searchBackgroundFilterReset() {
  return {
    type: SEARCH_BACKGROUND_FILTER_RESET_STATE,
  };
}

export function setSearchBackgroundFilterPageSize(data) {
  return {
    type: SEARCH_BACKGROUND_FILTER_PAGE_SIZE,
    data,
  };
}

export function searchBackgroundFilterMaintain(itemType, itemValue) {
  return (dispatch, getState) => {
    let searchBGFilterData = getState().searchBackgroundFilter.get('data');
    let searchConds = SearchFilter.updateSearchFilterItem(searchBGFilterData, itemType, itemValue, true);
    dispatch(searchBackgroundFilterMaintain_succ(searchConds));
    return searchConds;
  };
}
